import { Text, View } from "react-native";
import CustomCourseWorkContentMenu from "../../../components/navigation/CustomCourseWorkContentMenu/CustomCourseWorkContentMenu";
import React from "react";
import { useActiveCourse } from "../../../contexts/ActiveCourseContext";
import { useUpdateCourseMutation } from "../../../graphql/generated/graphql";

const CustomCourseworkMenuContainer = () => {
  const { modalState, courseData, courseLoading, handleSelectModule, handleSelectActivity, handleOpenAddModule } =
    useActiveCourse();

  const selectedCourse = courseData?.getCourseModulesActivitiesLite?.data[0];

  const [updateModuleOrderMutation] = useUpdateCourseMutation();

  const handleModuleDragEnd = async (data) => {
    await updateModuleOrderMutation({
      variables: {
        id: selectedCourse.id,
        course: {
          moduleOrder: data.map((item) => item.id),
        },
      },
    });
  };

  if (courseLoading)
    return (
      <View accessibilityRole="menu">
        <Text>Loading...</Text>
      </View>
    );

  return (
    <>
      {selectedCourse ? (
        <CustomCourseWorkContentMenu
          data={selectedCourse}
          onSelectModule={handleSelectModule}
          onSelectActivity={handleSelectActivity}
          selectedModule={modalState.activeModule}
          selectedActivity={modalState.activeActivity}
          onAddModule={handleOpenAddModule}
          onModuleDragEnd={handleModuleDragEnd}
        />
      ) : (
        <View accessibilityRole="menu">
          <Text>No courses available</Text>
        </View>
      )}
    </>
  );
};

export default CustomCourseworkMenuContainer;
